<mat-form-field style="width: 100%; margin-top: 10px;">
  <mat-label>Search</mat-label>
  <input (keyup)="searchChanged($event)" matInput name="searchField" [(ngModel)]="currentSearchTerm"
    placeholder="Search">
</mat-form-field>

<table mat-table matSort [dataSource]="dataSource" table-striped style="width: 100%">
  @for (col of display_fields; track col; let i = $index) {
    <ng-container [matColumnDef]=col>
      @if (templates[col]) {
        <th mat-header-cell class="table-header" *matHeaderCellDef mat-sort-header> {{column_names[i]}} </th>
        <td mat-cell *matCellDef="let item" class="table-cell-data" style="padding-right: 5px; max-width: 150px">
          <ng-template *ngTemplateOutlet="templates[col]; context: { $implicit: item }">
          </ng-template>
        </td>
      }
      @if (!templates[col]) {
        <th mat-header-cell class="table-header" *matHeaderCellDef mat-sort-header> {{column_names[i]}} </th>
        <td mat-cell *matCellDef="let item" class="table-cell-data" style="padding-right: 5px; max-width: 150px">
          @if (col === 'subscribe') {
            <div>
              <button mat-icon-button (click)="openSubscriptionDialog(item[apiKey])">
                <mat-icon class="subscription-icon">email</mat-icon>
              </button>
            </div>
          } @else {
            {{item[col]}}
          }
        </td>
      }
    </ng-container>
  }
  <tr mat-header-row *matHeaderRowDef="display_fields"></tr>
  <tr mat-row *matRowDef="let row; columns: display_fields;"></tr>
</table>
<mat-paginator pageSize="25" [length]="totalHits" (page)="onPageChange($event)"></mat-paginator>


<ng-template let-data #subscriptionTemplate>
  <div mat-dialog-content class="centerContents">
    <p class="mat-dialog-title-font">{{subscriptionDialogTitle}}</p>
    <form [formGroup]="subscriptionForm" novalidate>
      <p>
        <mat-form-field appearance="fill" [style.width.%]="100">
          <input matInput (input)="getEmail($event)" placeholder="Enter email" formControlName="subscriberEmail" id="subscriberEmail">
          <mat-hint align="end">Enter a valid email address.</mat-hint>
          @if (displayError('subscriberEmail', 'required')) {
            <mat-error>
              Email is required
            </mat-error>
          }
          @if (displayError('subscriberEmail', 'email')) {
            <mat-error>
              Please enter a valid email
            </mat-error>
          }
        </mat-form-field>
      </p>
    </form>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancelDialog('form')">Cancel</button>
      <button mat-button (click)="onRegister(data)" cdkFocusInitial>Register</button>
    </div>
  </div>
</ng-template>


<ng-template let-data #subscriptionInfoTemplate>
  <div mat-dialog-content class="centerContents">
    <div fxLayout="row" [ngClass]="subscription_status === 'success' ? 'alert alert-success' : 'alert alert-warning'">
      <div fxFlex="100">
        {{submission_message}}
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancelDialog('info')">Close</button>
  </div>
</ng-template>
